import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import UserMenu from '@Components/Common/UserMenu';
import UserMenuAdmin from '@Components/Common/UserMenuAdmin';
import Helpers from '@Apis/helpers';
import ErrorBoundry from './ErrorBoundry';
import Header from '../Common/Header';
import UserMenuCollapsedV3 from '../Common/UserMenuCollapsedV3';
import UserMenuAdminCollapsed from '../Common/UserMenuAdminCollapsed';
import UserMenuHover from '../Common/UserMenuHover';

import './style.scss';
import UserMenuAdminHover from '../Common/UserMenuAdminHover';

const checkMarginLessComponent = () => {
  const routeList = [
    // '/inventory/manage',
    // '/production/configurations',
  ];
  return routeList.includes(window.location.pathname)
    ? 'component-inner-wrapper-less-padding'
    : 'component-inner-wrapper';
};

const orgContainer = (Component) => {
  const UserMenuConfig = JSON.parse(localStorage.getItem("user_menu_config"));
  return (
    <Fragment>
        <div className={UserMenuConfig === "FIXED" ? "component-wrapper__outer" : "component-wrapper__outer-collapsible"}>
          <ErrorBoundry>
            <div className={`component-wrapper ${Helpers.hasExpiryNotification() ? 'component-wrapper-with-notification' : ''}`}>
              <Header />
              <div className={checkMarginLessComponent()}>
                <Component />
              </div>
            </div>
          </ErrorBoundry>
        </div>
    </Fragment>
  );
};

export default orgContainer;
